import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=80dea29e&scoped=true"
import script from "./applyList.vue?vue&type=script&lang=js"
export * from "./applyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dea29e",
  null
  
)

export default component.exports